<template>
    <div>
        <div>
            <img class="bmks" src="~@public/img/hotApply/icon_bmks.png">
        </div>
    </div>
</template>

<script>
    export default {
        name: "EasyLock"
    }
</script>

<style scoped>
    .bmks {
        width: 75%;
        margin: 4.0rem 1.0rem 1.0rem 1.2rem
    }
</style>